module.exports = __webpack_public_path__ + "img/bg.74887cb3.png";